export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount || 0);
};

// Yuklenen dosyalar (foto/PDF) API host'undan sunulur (/api olmadan) — /uploads/... -> tam URL
export const ASSET_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5001/api').replace(/\/api\/?$/, '');
export const assetUrl = (p) => {
  if (!p) return '';
  if (/^https?:\/\//.test(p) || p.startsWith('data:')) return p;
  return `${ASSET_BASE}${p.startsWith('/') ? '' : '/'}${p}`;
};

export const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('de-DE');
};

export const formatDateTime = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleString('de-DE');
};

export const getStatusColor = (status) => {
  const colors = {
    aktif: 'bg-green-100 text-green-800',
    beklemede: 'bg-yellow-100 text-yellow-800',
    pasif: 'bg-gray-100 text-gray-800',
    reddedildi: 'bg-red-100 text-red-800',
    odendi: 'bg-green-100 text-green-800',
    odenmedi: 'bg-red-100 text-red-800',
    kismen_odendi: 'bg-yellow-100 text-yellow-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const getStatusLabel = (status) => {
  const labels = {
    aktif: 'Aktif',
    beklemede: 'Beklemede',
    pasif: 'Pasif',
    reddedildi: 'Reddedildi',
    odendi: 'Ödendi',
    odenmedi: 'Ödenmedi',
    kismen_odendi: 'Kısmen Ödendi'
  };
  return labels[status] || status;
};

export const getMonthName = (month) => {
  const months = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
  return months[month - 1] || '';
};
